import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse'
import { getSpendByLocationKey } from './keys'
import { SpendByLocation, getSpendByLocation } from 'api/pulse/spendByLocation'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useSpendByLocation(query: PulsePaginatedFilters) {
  return useInfiniteQuery<SpendByLocation>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getSpendByLocationKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getSpendByLocation(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
  })
}
